import { render, staticRenderFns } from "./giroform.vue?vue&type=template&id=859573ea"
import script from "./giroform.vue?vue&type=script&lang=js"
export * from "./giroform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports